import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import blockStyles from '../styles/block.styles';
export default css `
  ${componentStyles}
  ${blockStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    --bg: #fff;
  }

  .video-item {
    position: relative;
    border-radius: var(--p-video-item-radius, 5px);
    max-width: 100vw;
  }

  .thumbnail-link {
    display: block;
    color: currentColor;
    text-decoration: none;
  }

  .video-item .thumbnail-link:hover .thumbnail img {
    transform: scale(1.04);
  }
  @media (prefers-reduced-motion) {
    .video-item .thumbnail-link:hover .thumbnail img {
      transform: none;
    }
  }

  .video-item .thumbnail-link:hover .thumbnail .play,
  .video-item .thumbnail-link:focus-within .thumbnail .play {
    transform: scale(1);
    opacity: 1;
  }

  .video-item .thumbnail-link:hover .title,
  .video-item .thumbnail-link:focus-within .title {
    color: var(--p-link-text-color-hover);
    text-decoration: var(--p-link-text-decoration-hover);
  }

  .text-container {
    padding: 0 0.3rem;
  }

  .thumbnail {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    aspect-ratio: 16/9;
    border-radius: var(--p-video-item-radius, 5px);
    margin-bottom: 0.8rem;
  }

  .thumbnail img {
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: cover;
    transition: transform 0.7s ease-out;
  }
  @media (prefers-reduced-motion) {
    .thumbnail img {
      transition: none;
    }
  }

  .play {
    position: relative;
    opacity: 0;
    transform: scale(0.9);
    transition:
      transform 350ms cubic-bezier(0.175, 0.885, 0.385, 1.85),
      opacity 200ms;
  }
  @media (prefers-reduced-motion) {
    .play {
      transition: none;
    }
  }

  .duration {
    font-size: var(--p-font-size-smallest);
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
    border-radius: var(--p-video-item-radius, 5px);
    top: 5px;
    color: #fff;
    line-height: 1;
    text-transform: uppercase;
    font-style: normal;
    padding: 5px 7px 4px;
  }

  .duration {
    right: 5px;
  }

  .live-badge {
    position: absolute;
    left: 5px;
    top: 5px;
  }

  .title {
    display: block;
    font-family: var(--p-h6-font);
    font-size: var(--p-h6-font-size);
    font-weight: var(--p-h6-font-weight);
    font-style: var(--p-h6-font-style);
    line-height: 1.2;
    text-transform: var(--p-h6-transform);
    letter-spacing: var(--p-h6-letter-spacing);
    margin-bottom: var(--p-h6-margin-bottom);
    color: var(--p-link-text-color);
    text-decoration: var(--p-link-text-decoration);
  }

  .published,
  .description {
    display: inline-block;
    line-height: 1.4;
    font-size: var(--p-font-size-small);
  }

  .description {
    font-size: 0.875rem;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  /**
--------------------------------------------------
* Upcoming
--------------------------------------------------
*/
  .upcoming .upcoming-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.65);
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--p-text-color-light);
    text-align: center;
  }

  .upcoming .upcoming-badge {
    position: absolute;
    left: 5px;
    top: 5px;
  }

  /**
--------------------------------------------------
* Type banner
--------------------------------------------------
*/
  .banner {
    max-width: 650px;
  }

  .banner .thumbnail-link {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.75rem;
  }

  .banner .thumbnail {
    aspect-ratio: 16/9;
    width: 120px;
    margin: 0;
  }
  .banner .text-container {
    padding: 0;
    flex-grow: 1;
  }

  .banner .description {
    font-size: 0.875rem;
    margin: 0.3rem 0 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    opacity: var(--p-text-meta-opacity);
  }

  .banner .play {
    width: 20px;
    height: 20px;
  }

  /**
--------------------------------------------------
* Preview
--------------------------------------------------
*/
  :host([preview]) {
    background-color: rgba(0, 0, 0, 0.1);
    height: 300px;
    border-radius: 10px;
  }

  :host([dark][preview]) {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;
